import React, { useContext, Fragment, useRef, useState, useEffect } from "react"
import { StateContext } from "./provider"
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react"
import { StaticImage } from "gatsby-plugin-image"
import { navigate } from "gatsby"
// import googleTag from "../googleTag"
import { twMerge } from "tailwind-merge"

export default function MarketingPop() {
  const [open, setOpen] = useState(false)
  const { statePopup } = useContext(StateContext)
  const [sitePopup, setSitePopup] = statePopup
  const cancelButtonRef = useRef(null)

  // PAGE CONTENT
  const popupTitle = "Optimize AAV & Protein Production!"
  const popupContent =
    "Join our webinar on July 29 to master the baculovirus & insect cell platform for high yield biomanufacturing. Our guest speaker, Dr. Thera Mulvania, President of Expression Systems, explores cutting-edge strategies for AAV & Protein production using Thomson's Optimum Growth® Flasks and 6-Well Plates."
  const popupImage = "webinarpopup.jpg"

  // buttons
  const btnOne = {
    color: "blue",
    label: "Save Your Spot Today!",
    href: "/events/webinar-07292025/",
  }
  //   href: "/form/BjkbJKbn",
  const btnTwo = false

  const clickResponce = page => {
    setOpen(false)
    setSitePopup(false)
    navigate(page.href)
  }
  // const disclaimerClickResponce = () => {
  //   setOpen(false)
  //   setSitePopup(false)
  // }
  const handleClose = () => {
    setOpen(false)
    setSitePopup(false)
  }

  useEffect(() => {
    if (sitePopup) {
      setOpen(true)
    }
  }, [])
  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={handleClose}
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mx-auto flex h-auto w-full items-center justify-center">
                    <StaticImage
                      className="h-full w-full"
                      src={`../../images/page/marketing/${popupImage}`}
                      alt="Thomson Solutions At Work"
                      placeholder="blurred"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <DialogTitle
                      as="h3"
                      className="text-xl font-bold leading-6 text-slate-800"
                    >
                      {popupTitle}
                    </DialogTitle>
                    <div className="mt-2">
                      <p
                        className="text-sm text-slate-500"
                        dangerouslySetInnerHTML={{ __html: popupContent }}
                      ></p>
                    </div>
                  </div>
                </div>
                <div
                  className={`mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-1 sm:gap-3 ${btnOne && btnTwo ? "lg:grid-cols-2" : "lg:grid-cols-1"}`}
                >
                  {btnOne && (
                    <Button
                      color={btnOne.color}
                      onClick={() => clickResponce(btnOne)}
                      ref={cancelButtonRef}
                    >
                      {btnOne.label}
                    </Button>
                  )}
                  {btnTwo && (
                    <Button
                      color={btnTwo.color}
                      onClick={() => clickResponce(btnTwo)}
                      ref={cancelButtonRef}
                    >
                      {btnTwo.label}
                    </Button>
                  )}
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

const Button = React.forwardRef((props, ref) => {
  return (
    <div
      className={twMerge([
        "rounded-md",
        props.light ? "" : "shadow",
        props.className,
      ])}
    >
      <button
        ref={ref}
        type="button"
        onClick={props.onClick}
        disabled={props.disabled}
        className={twMerge([
          "flex w-full items-center justify-center rounded-md border border-transparent py-3 text-base font-medium leading-6 transition focus:outline-none",
          props.color === "gray" &&
            "bg-slate-100 text-slate-800 hover:bg-slate-200",
          props.color === "gray" && props.active && "bg-slate-200",
          props.color === "pink" &&
            "bg-pink-100 text-pink-800 hover:bg-pink-200",
          props.color === "pink" && props.active && "bg-pink-200",
          props.color === "red" &&
            "bg-rose-100 text-rose-800 hover:bg-rose-200",
          props.color === "red" && props.active && "bg-rose-200",
          props.color === "orange" &&
            "bg-orange-100 text-orange-800 hover:bg-orange-200",
          props.color === "orange" && props.active && "bg-orange-200",
          props.color === "yellow" &&
            "bg-amber-100 text-amber-800 hover:bg-amber-200",
          props.color === "yellow" && props.active && "bg-amber-200",
          props.color === "green" &&
            "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
          props.color === "green" && props.active && "bg-emerald-200",
          props.color === "teal" &&
            "bg-teal-100 text-teal-800 hover:bg-teal-200",
          props.color === "teal" && props.active && "bg-teal-200",
          props.color === "blue" &&
            "bg-blue-100 text-blue-800 hover:bg-blue-200",
          props.color === "blue" && props.active && "bg-blue-200",
          props.color === "purple" &&
            "bg-violet-100 text-violet-800 hover:bg-violet-200",
          props.color === "purple" && props.active && "bg-violet-200",
          props.color === "indigo" &&
            "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
          props.color === "indigo" && props.active && "bg-indigo-200",
        ])}
      >
        {props.children}
      </button>
    </div>
  )
})
